import React from 'react';
import Router from 'next/router';

import DoubleTitle from 'components/DoubleTitle';
import Text from 'components/core/Text';
import { Wrapper, Description, LinkButton } from './styles';

const Index = () => {
  return (
    <Wrapper>
      <DoubleTitle
        title="COMPLETE"
        subTitle="YOUR PROFILE TO&nbsp;GET&nbsp;PERSONALIZED RECOMMENDATIONS"
      />
      <Description>
        <Text variant="textSmall" color="gray">
          Tap below to answer a few questions about you and your fitness goals. This will help us
          provide recommendations tailored to you! You&apos;ll be able to update your responses at
          any time in your profile.
        </Text>
      </Description>
      <LinkButton secondary handleClick={() => Router.push('/questionnaire')}>
        <Text tag="span" weight="bold">
          Let&apos;s Do It!
        </Text>
      </LinkButton>
    </Wrapper>
  );
};

export default Index;
